module.exports = __webpack_public_path__ + "static/img/advantage2.425fe0a0.png";